<template>
  <div class="box" v-if="showPlan">
    <div class="box-title">
      <div class="text">{{ showPlanInfo.title }}</div>
      <img src="../../../public/image/runcontrol/showPlan/showPlan-title.png" alt="" />

      <span class="box-close" @click="closePlanDetail">
        <img src="../../../public/image/runcontrol/icon_close.png" alt="" />
      </span>
    </div>

    <!-- <div class="box-top"></div> -->

    <div class="box-content">
      <div class="content-item">
        <div class="col-item">
          <div class="col-item-title">基本信息</div>
          <div class="col-item-content">
            <div class="show-case">
              <div class="item-li">
                <div class="li-label over-scroll" style="height: 35px">
                  申请单位
                </div>
                <div class="li-content over-scroll" style="height: 35px">
                  {{ showPlanInfo.unitname }}
                </div>
              </div>
              <div class="item-li">
                <div class="li-label">联系方式</div>
                <div class="li-content">{{ showPlanInfo.contacttype }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">机长</div>
                <div class="li-content">{{ showPlanInfo.contactman }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">飞行区域</div>
                <div class="li-content over-scroll" style="height: 35px">
                  {{ showPlanInfo.flightarea }}
                </div>
              </div>
            </div>
            <div class="show-case">
              <div class="item-li">
                <div class="li-label">计划架次</div>
                <div class="li-content">{{ showPlanInfo.planflynum }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">应答机编码</div>
                <div class="li-content over-scroll" style="height: 35px">
                  {{ showPlanInfo.transpondercode }}
                </div>
              </div>
              <div class="item-li">
                <div class="li-label">计划类型</div>
                <div class="li-content">{{ showPlanInfo.plantype }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">任务批件</div>
                <div class="li-content">
                  <div
                    class="fileRouder"
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      cursor: pointer;
                      color: #409eff;
                    "
                    v-for="item in showPlanInfo.planfiles"
                    :key="item.id"
                    @click="toFile(item)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-item">
          <div class="col-item-title">机场</div>
          <div class="col-item-content">
            <div class="show-case">
              <div class="item-li">
                <div class="li-label">起飞机场</div>
                <div class="li-content">
                  {{ showPlanInfo.departureairport }}
                </div>
              </div>
            </div>
            <div class="show-case">
              <div class="item-li">
                <div class="li-label">降落机场</div>
                <div class="li-content">{{ showPlanInfo.landingairport }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-item">
          <div class="col-item-title">起降点</div>
          <div class="col-item-content over-scroll" style="height: 70px">
            <div class="item-li">
              <div class="li-all">
                <p v-for="item in showPlanInfo.landingpoints" :key="item.id">
                  {{ item.title }} ( {{ getla(item) }} , {{ getlo(item) }})
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item">
        <div class="col-item">
          <div class="col-item-title">民航管制区</div>
          <div
            class="col-item-content flex-col over-scroll"
            style="height: 70px"
          >
            <p>区调值班电话：88730257</p>
            <p>站调值班电话：89981003</p>
            <p>进近值班电话：84798452</p>
          </div>
        </div>

        <div class="col-item">
          <div class="col-item-title">时间</div>
          <div class="col-item-content">
            <div class="show-case">
              <div class="item-li">
                <div class="li-label">计划开始时间</div>
                <div class="li-content">{{ showPlanInfo.begindate }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">计划提交时间</div>
                <div class="li-content">{{ showPlanInfo.createtime }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">实际开始时间</div>
                <div class="li-content">{{ showPlanInfo.flystarttime }}</div>
              </div>
            </div>
            <div class="show-case">
              <div class="item-li">
                <div class="li-label">计划结束时间</div>
                <div class="li-content">{{ showPlanInfo.enddate }}</div>
              </div>
              <div class="item-li">
                <div class="li-label">放行申请时间</div>
                <div class="li-content">
                  {{ showPlanInfo.flyofficialoperattime }}
                </div>
              </div>
              <div class="item-li">
                <div class="li-label">实际结束时间</div>
                <div class="li-content">{{ showPlanInfo.flyendtime }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-item">
          <div class="col-item-title">计划关联管制区</div>
          <div class="col-item-content over-scroll" style="height: 70px">
            <div>
              <div
                class="item-li"
                v-for="item in AirportControlZoneByPlanData"
                :key="item.id"
              >
                <div class="li-all">
                  管制单位：{{ item.username }}---- 手机号：{{ item.phone }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item">
        <div class="col-item">
          <div class="col-item-title">可用飞机</div>
          <div class="col-item-content flex-col over-scroll">
            <p v-for="item in showPlanInfo.aircrafts" :key="item.id">
              {{ item.sn }}- {{ item.devicetype }}-
              {{ aircraftcategoryType(item.aircraftcategory) }};ICAO:{{
                item.icao
              }}; 北斗卡号：{{ item.beidouno }}
            </p>
          </div>
        </div>
        <div class="col-item">
          <div class="col-item-title">审批状态</div>
          <div class="col-item-content">
            <div class="item-li">
              <div class="li-all">
                <div v-if="showPlanInfo.status === 'DRAFT'">
                  <el-tag :type="'info'"> 草稿 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'DRAFTPLAN'">
                  <el-tag :type="'danger'"> 飞行计划驳回自行编辑 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN'">
                  <el-tag :type="'info'"> 飞行计划已提交 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN01'">
                  <el-tag :type="'warning'"> 飞行计划已提交民航 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN02'">
                  <el-tag :type="''"> 飞行计划民航已批复 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN10'">
                  <el-tag :type="'warning'"> 飞行计划已提交军方 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN11'">
                  <el-tag :type="'warning'"> 飞行计划已提交军方 </el-tag>
                  <el-tag :type="'warning'"> 飞行计划已提交民航 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN12'">
                  <el-tag :type="'warning'">飞行计划已提交军方 </el-tag>
                  <el-tag :type="''"> 飞行计划民航已批复 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN20'">
                  <el-tag :type="'warning'"> 飞行计划军方已批复 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PENDINGPLAN21'">
                  <el-tag :type="''">飞行计划军方已批复 </el-tag>
                  <el-tag :type="'warning'"> 飞行计划已提交民航 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'PASSEDPLAN'">
                  <el-tag :type="'success'"> 飞行计划已批复 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'FAILEDPLAN'">
                  <el-tag :type="'danger'"> 飞行计划已驳回 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'FAILEDPLAN1'">
                  <el-tag :type="'danger'"> 飞行计划军方已驳回 </el-tag>
                </div>
                <div v-if="showPlanInfo.status === 'FAILEDPLAN2'">
                  <el-tag :type="'danger'"> 飞行计划民航已驳回</el-tag>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-item">
          <div class="col-item-title">作业区域</div>
          <div class="col-item-content flex-col over-scroll">
            <div class="item-li over-scroll">
              <div class="li-all">{{ showPlanInfo.lineandarea }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { getAirportControlZoneByPlanid } from "../../request/api";
export default {
  data() {
    return { AirportControlZoneByPlanData: null };
  },
  computed: {
    ...mapGetters({
      showPlan: "swichLayer/showPlan",
      showPlanInfo: "swichLayer/showPlanInfo",
    }),
  },

  methods: {
    ...mapMutations({
      initPlanshow: "swichLayer/initPlanshow",
    }),
    ...mapActions({
      startDataDrawAction: "drawMap/startDataDrawAction",
      stopDrawAction: "drawMap/stopDrawAction",
    }),
    aircraftcategoryType(status) {
      if (status === "AIRCRAFT") {
        return "固定翼飞机";
      } else if (status === "ROTORCRAFT") {
        return "旋翼机";
      } else if (status === "UNMANNEDAV") {
        return "无人机";
      } else if (status === "HELICOPTER") {
        return "直升机";
      } else if (status === "AIRSHIP") {
        return "飞艇";
      } else if (status === "PRIMARY_AIRCRAFT") {
        return "初级飞机";
      } else if (status === "ROTATION_ROTORCRAFT") {
        return "自转旋翼机";
      } else if (status === "GLIDER") {
        return "滑翔机";
      } else if (status === "FREE_BALLOON") {
        return "自由气球";
      } else if (status === "BLIMP") {
        return "小型飞艇";
      }
    },
    statusD(status) {
      if (status === "DRAFT") {
        return "草稿";
      } else if (status === "PENDINGPLAN") {
        return "飞行计划已提交";
      } else if (status === "DRAFTPLAN") {
        return "飞行计划驳回编辑中";
      } else if (status === "FAILEDPLAN") {
        return "飞行计划已驳回";
      } else if (status === "FAILEDPLAN1") {
        return "飞行计划军方已驳回";
      } else if (status === "FAILEDPLAN2") {
        return "飞行计划民航已驳回";
      } else if (status === "PENDINGPLAN") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN01") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN02") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN10") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN11") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN12") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN20") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN21") {
        return "飞行计划已提交";
      } else if (status === "PENDINGPLAN22") {
        return "飞行计划已提交";
      } else if (status === "PASSEDPLAN") {
        return "飞行计划已批复";
      }
    },

    toFile(item) {
      window.open(this.$imgURL + "/" + item.showpath);
    },
    getlo(item) {
      //E经度
      let lo = ToDegrees(item.lo);
      return lo[0] + "°" + lo[1] + "′" + lo[2] + "′′" + "E";
    },
    getla(item) {
      //N纬度
      let la = ToDegrees(item.la);
      return la[0] + "°" + la[1] + "′" + la[2] + "′′" + "N";
    },
    async getAirportControlZoneByPlan() {
      let res = await getAirportControlZoneByPlanid({
        id: this.showPlanInfo.id,
      });
      this.AirportControlZoneByPlanData = res;
    },
    closePlanDetail() {
      this.initPlanshow(false);
      this.stopDrawAction();
    },
  },
  mounted() {
    this.getAirportControlZoneByPlan();
  },
};
</script>

<style lang="less" scoped>
.box {
  display: inline-block;
  text-align: left;
  width: 100%;
  height: 450px;
  background: linear-gradient(
    180deg,
    rgba(13, 49, 87, 0.83) 0%,
    rgba(7, 22, 38, 0.83) 11%,
    rgba(5, 23, 49, 0.83) 93%,
    rgba(13, 48, 87, 0.83) 100%
  );
  padding: 10px;
  border: 1px solid #1b3a4f;
}

.box-title {
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
  position: relative;
  color: #fff;

  .text {
    position: absolute;
    left: 50px;
  }

  img {
    width: 460px;
    height: 30px;
  }

  .box-close {
    position: absolute;
    right: 20px;
    cursor: pointer;

    img {
      width: 35px;
      height: 35px;
    }
  }
}

.box-top {
  height: 60px;
}

.box-content {
  display: flex;
  justify-content: flex-start;
  color: #fff;

  .content-item {
    flex: 1;
    overflow: hidden;
    margin: 0 5px;

    .col-item {
      margin-bottom: 15px;
      .col-item-title {
        padding-left: 20px;
        height: 30px;
        font-size: 14px;
        font-family: AppleSystemUIFont;
        color: #56cef6;
        line-height: 17px;
      }

      .col-item-content {
        width: 100%;
        display: flex;
        padding: 0 10px;
        background-color: rgba(0, 0, 0, 0.25);
        .show-case {
          width: 50%;
          height: 100%;
        }
      }
    }
  }
}
.item-li {
  display: flex;
  width: 100%;
  min-height: 35px;
  line-height: 35px;
  font-size: 12px;
  font-family: AppleSystemUIFont;
  color: rgba(255, 255, 255, 0.85);

  .li-all {
    width: 100%;
    padding: 0 5px;
  }

  .li-label {
    flex: 0.4;
    padding: 0 5px;
  }
  .li-content {
    flex: 0.6;
    padding: 0 5px;
  }
}

.flex-col {
  flex-direction: column;
}

.over-scroll {
  overflow-y: scroll;
  height: 100px;
}

.over-scroll::-webkit-scrollbar {
  width: 10px;
  height: 15px;
}
.over-scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: linear-gradient(270deg, #1a3c53 0%, #14395a 100%);
  border-radius: 9px;
  border: 1px solid rgba(151, 151, 151, 0.4);
}
.over-scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.over-scroll::-webkit-scrollbar-corner {
  /*滚动条里面轨道*/

  background: rgba(0, 0, 0, 0.1);
}
</style>